import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('ColumnStatistics');

export const LOAD_COLUMN_STATISTICS = apiType('LoadColumnStatistics');
export const CANCEL_COLUMN_STATISTICS = apiType('CancelColumnStatistics');
export const LOAD_VIEW_CARDINALITY = apiType('LoadViewCardinality');
